import * as React from 'react';
import { ImageObject, Content, SvgImage } from '../common';
import ImageBlockProps from './type';
import './styles.scss';

const ImageBlockRight = ({
  title,
  intro,
  content,
  image,
  link,
  themeColor,
}: ImageBlockProps) => (
  <div className="image-block">
    <div className="image-block__item image-block__image image-block__image--mobile">
      <div className="image-block__image-inner">
        <ImageObject
          image={image}
          widthSizes={['400', '800', '1200']}
        />
      </div>
    </div>
    <div className={`image-block__item image-block__content image-block__content--${themeColor}`}>
      <Content
        title={title}
        intro={intro}
        content={content}
        link={link}
        containerTheme={themeColor}
      />
    </div>
    <div className="image-block__item image-block__image image-block__image--desktop">
      <div className="image-block__image-inner">
        <ImageObject
          image={image}
          widthSizes={['400', '800', '1200']}
          aspectRatio="1x1"
        />
      </div>
    </div>
  </div>
);

const ImageBlockLeft = ({
  title,
  intro,
  content,
  image,
  link,
  themeColor,
}: ImageBlockProps) => (
  <div className="image-block">
    <div className="image-block__item image-block__image">
      <div className="image-block__image-inner">
        <ImageObject
          image={image}
          widthSizes={['400', '800', '1200']}
        />
      </div>
    </div>
    <div className={`image-block__item image-block__content image-block__content--${themeColor}`}>
      <Content
        title={title}
        intro={intro}
        content={content}
        link={link}
        containerTheme={themeColor}
      />
    </div>
  </div>
);

const ImageBlockTop = ({
  title,
  intro,
  content,
  image,
  link,
  themeColor,
}: ImageBlockProps) => (
  <div className="image-block image-block--top">
    <div className="image-block__item image-block__image">
      <div className="image-block__image-inner">
        <ImageObject
          image={image}
          widthSizes={['400', '800', '1200']}
        />
      </div>
    </div>
    <div className={`image-block__item image-block__content image-block__content--${themeColor}`}>
      <Content
        title={title}
        intro={intro}
        content={content}
        link={link}
        containerTheme={themeColor}
      />
    </div>
  </div>
);

const ImageBlockPromo = ({
  title,
  image,
  link,
  themeColor,
  isPromoTile,
  disableUppercase,
}: ImageBlockProps) => (
  <div className={`image-block ${isPromoTile ? 'image-block--promo-tile' : 'image-block--promo'} image-block--theme-${themeColor}`}>
    <div className="image-block__item image-block__image">
      <div className="image-block__image-inner">
        <ImageObject
          image={image}
          widthSizes={['400', '800', '1200']}
        />
      </div>
    </div>
    <div className="image-block__item image-block__content-wrapper">
      <div className="image-block__item image-block__content-wrapper__inner">
        <div className="image-block__item image-block__content">
          <div className="content">
            <h2 className={`content__title ${disableUppercase ? 'disable-uppercase' : ''}`}>{title}</h2>
            {link && (
              /* eslint-disable-next-line react/jsx-no-target-blank */
              <a
                href={link.url}
                className="content__link"
                target={link.isExternal ? '_blank' : '_self'}
                rel={link.isExternal ? 'noopener noreferrer' : ''}
              >
                {link.title}
                <SvgImage ariaHidden reference="#icon-think-arrow" />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ImageBlock = ({
  position = 'left',
  image,
  themeColor,
  ...rteProps
}: ImageBlockProps) => {
  if (position === 'top') {
    return <ImageBlockTop image={image} themeColor={themeColor} {...rteProps} />;
  }

  if (position === 'promo') {
    return <ImageBlockPromo image={image} themeColor={themeColor} {...rteProps} />;
  }

  if (position === 'right') {
    return <ImageBlockRight image={image} themeColor={themeColor} {...rteProps} />;
  }

  return <ImageBlockLeft image={image} themeColor={themeColor} {...rteProps} />;
};

export default ImageBlock;
